import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { Observable } from 'rxjs';
import { Esquema } from '../models/esquema';
import { environment } from '../../environments/environment';

const baseUrl = environment.hostService + '/Esquema';

@Injectable({
  providedIn: 'root'
})
export class EsquemaService {

  constructor(private _http: HttpClientService) { }

  getAll(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/Index' })
  }

  save(esquema: Esquema)
  {
    return this._http.post({ url: baseUrl + '/Save', body: esquema });
  }

  delete(id: number)
  {
    return this._http.get<any>({ url: baseUrl + '/Delete?id=' + id });   
  }

  liquidar(id: number, especial: boolean, baja: boolean)
  {
    return this._http.post<any>({ url: baseUrl + '/Liquidar?esquemaid=' + id + '&especial=' + especial + '&baja=' + baja});
  }

  getFuntions(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/GetFunctions' })
  }
}

